import React from 'react';
import { motion } from 'framer-motion';
import Hero from './components/LandingPageComponenets/Hero';
import Hero2 from './components/LandingPageComponenets/Hero2';
import ConsolidatedCards from "./components/LandingPageComponenets/ConsolidatedCards";
import Track from "./components/LandingPageComponenets/Track";
import Header from './components/Header';
import Footer from './components/Footer';
import './LandingPage.css';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5 } }
};

const slideUp = {
  hidden: { y: 50, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.5 } }
};

export default function LandingPage() {
  return (
    <motion.div 
      className="landing-page"
      initial="hidden"
      animate="visible"
      variants={fadeIn}
    >
      <div className="lp_background-image"></div>
      <div className="lp_content">
        <motion.div variants={slideUp}>
          <Header />
        </motion.div>
        <motion.div variants={slideUp}>
          <Hero />
        </motion.div>
          <Hero2 />
        <motion.div variants={slideUp}>
          <Track />
        </motion.div>
        <motion.img 
          src="images/Vector11.png" 
          alt="" 
          variants={fadeIn}
        />
        <motion.div variants={slideUp}>
          <ConsolidatedCards />
        </motion.div>
        <motion.img 
          src="images/footerWave1.png" 
          className='bg-[#1D1534]' 
          alt="" 
          variants={fadeIn}
        />
        <motion.div variants={slideUp}>
          <Footer/>
        </motion.div>
      </div>
    </motion.div>
  );
}